import { CollapsibleContent } from '@schibsted-svp/react-ui';
import useToggle from 'hooks/useToggle';
import { HistoryList } from './HistoryList';
import { useGetCategoryHistoryData, useHistoryPreview } from './hooks';
import { HistoryPreview } from './HistoryPreview';
import css from './History.module.scss';

type HistoryProps = {
    provider: string;
    categoryId: number;
};

export function History({ provider, categoryId }: HistoryProps) {
    const [isExpanded, toggleIsExpanded] = useToggle(false);
    const { historyData, isLoading, isError } = useGetCategoryHistoryData(provider, categoryId, isExpanded);
    const { previewData, isPreviewOpen, openPreview, closePreview } = useHistoryPreview();

    return (
        <CollapsibleContent label="History" expanded={isExpanded} onToggle={toggleIsExpanded}>
            <section className={css.content}>
                <HistoryList data={historyData} isLoading={isLoading} isError={isError} openPreview={openPreview} />
                {previewData && (
                    <HistoryPreview data={previewData} isDialogOpen={isPreviewOpen} closeDialog={closePreview} />
                )}
            </section>
        </CollapsibleContent>
    );
}
